import { useReducer, useCallback, createContext, useEffect } from 'react';
import { Actions, UseFindTheObjectState } from './types';
import { reducers, initialState } from './reducers';
import { FindTheObjectInterface, ObjectsType } from '../GameProvider/types';
import useGame from '../../hooks/use-game';
import useHint from '../../hooks/use-hint';
import usePage from '../../hooks/use-page';
import useProgress from '../../hooks/use-progress';
import { getAllObjects, getObjectHint } from '../../util/find-the-object-util';

export const FindTheObjectContext = createContext<any>([]);

export const FindTheObjectProvider: React.FC<any> = ({ children }) => {
  const [, { setTotal, setFound }] = useProgress();
  const [{ currentData }] = useGame<FindTheObjectInterface>();
  const [{ showHint }] = useHint();
  const [{ currentPage }] = usePage();

  const [state, dispatch] = useReducer<React.Reducer<UseFindTheObjectState, Actions>>(
    reducers,
    initialState
  );

  const setObjects = useCallback(
    (objects: ObjectsType[]) => {
      dispatch({ type: 'SET_OBJECTS', payload: { objects } });
    },
    [state, dispatch]
  );

  const setFoundObjectTags = useCallback(
    (page: number, objectTag: string) => {
      if (!state.pages[page]?.foundObjectTags?.includes(objectTag)) {
        setFound(page);
      }
      dispatch({ type: 'SET_FOUND_OBJECT_TAGS', payload: { page, objectTag } });
    },
    [dispatch]
  );

  useEffect(() => {
    if (!currentData) return;

    const allObjects: ObjectsType[] = getAllObjects(currentData);
    setObjects(allObjects);
    setTotal(currentData[0].page?.pageNumber, allObjects.length);
  }, [currentData]);

  useEffect(() => {
    dispatch({
      type: 'SET_HINT_TAG',
      payload: {
        hintTag: showHint
          ? getObjectHint(currentData, state.pages[currentPage]?.foundObjectTags)
          : undefined,
      },
    });
  }, [showHint]);

  return (
    <FindTheObjectContext.Provider
      value={[
        state,
        {
          setFoundObjectTags,
        },
      ]}
    >
      {children}
    </FindTheObjectContext.Provider>
  );
};

export default FindTheObjectProvider;
